// extracted by mini-css-extract-plugin
export var container = "SearchBar-module--container--e0961";
export var crossIconContainer = "SearchBar-module--cross-icon-container--9e1e0";
export var isLoggedIn = "SearchBar-module--is-logged-in--e2c7c";
export var searchIconContainerDesktop = "SearchBar-module--search-icon-container-desktop--62feb";
export var searchIconContainerMobile = "SearchBar-module--search-icon-container-mobile--874a3";
export var searchInput = "SearchBar-module--search-input--97ffd";
export var searchInputHeader = "SearchBar-module--search-input-header--f4799";
export var searchInputHomepage = "SearchBar-module--search-input-homepage--59d95";
export var searchResultsContainer = "SearchBar-module--search-results-container--e11c4";
export var searchTakoverActive = "SearchBar-module--search-takover-active--40746";
export var searchTextContainer = "SearchBar-module--search-text-container--9378d";
export var takeoverActive = "SearchBar-module--takeover-active--b5fd8";
export var takeoverInactive = "SearchBar-module--takeover-inactive--b36f0";